<i18n>
{
  "en": {
    "pages": {
      "ChangePassword": {
        "title": "Change password",
        "oldPassword": "Old password",
        "newPassword": "New password",
        "repeatedPassword": "Repeat password",
        "messages": {
          "success": "An e-mail was sent to your address.",
          "serverDown": "Server probably down.",
          "unauthorized": "Permission denied: maybe your session has expired.",
          "validation": "All fields are required. The last two must match.",
          "default": "Generic error. Please, contact the server administrator."
        },
        "actions": {
          "submit": "Submit"
        }
      }
    }
  },
  "it": {
    "pages": {
      "ChangePassword": {
        "title": "Cambia password",
        "oldPassword": "Vecchia password",
        "newPassword": "Nuova password",
        "repeatedPassword": "Ripeti password",
        "messages": {
          "success": "Un'e-mail è stata inviata al tuo indirizzo.",
          "serverDown": "Server non raggiungibile.",
          "unauthorized": "Permesso negato: la sessione potrebbe essere scaduta.",
          "validation": "Tutti i campi sono richiesti. Gli ultimi due debbono coincidere.",
          "default": "Errore generico. Si prega di contattare l'amministratore."
        },
        "actions": {
          "submit": "Procedi"
        }
      }
    }
  }
}
</i18n>
<template>
  <div class="d-flex flex-row align-items-center my-5">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card
              no-body
              class="p-4">
              <b-card-body>
                <form @submit.prevent="changePassword()">
                  <h1 v-t="'pages.ChangePassword.title'"/>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key" /></b-input-group-text></b-input-group-prepend>
                    <input
                      v-model="request.oldPassword"
                      type="password"
                      class="form-control"
                      :placeholder="$t('pages.ChangePassword.oldPassword')">
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key" /></b-input-group-text></b-input-group-prepend>
                    <input
                      v-model="request.newPassword"
                      type="password"
                      class="form-control"
                      :placeholder="$t('pages.ChangePassword.newPassword')">
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key" /></b-input-group-text></b-input-group-prepend>
                    <input
                      v-model="request.repeatedPassword"
                      type="password"
                      class="form-control"
                      :placeholder="$t('pages.ChangePassword.repeatedPassword')">
                  </b-input-group>
                  <b-alert
                    v-if="message"
                    :variant="variant"
                    show>
                    {{ message }}
                  </b-alert>
                  <b-row>
                    <b-col
                      cols="12"
                      class="text-right">
                      <input
                        type="submit"
                        class="btn btn-primary px-4"
                        :disabled="!canSubmit"
                        :value="$t('pages.ChangePassword.actions.submit')">
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import UserService from 'vue-core/services/UserService';

export default {
  data() {
    return {
      request: {
        oldPassword: null,
        newPassword: null,
        repeatedPassword: null
      },
      canSubmit: true,
      message: null,
      variant: null,
    };
  },

  methods: {
    changePassword() {
      const self = this;
      self.canSubmit = false;

      function success({ statusCode, data }) {
        self.message = self.$t('pages.ChangePassword.messages.success');
        self.variant = 'success';
      }

      function error({ statusCode, data }) {
        console.log('Error', statusCode, data);
        self.variant = 'danger';
        switch (statusCode) {
          case 0:
            console.log(0);
            self.message = self.$t('pages.ChangePassword.messages.serverDown');
            break;
          case 401: /* Unauthorized */
            console.log(401);
            self.message = self.$t('pages.ChangePassword.messages.unauthorized');
            break;
          case 403: /* Forbidden */
            console.log(403);
            self.message = data;
            break;
          case 422: /* Validation error */
            console.log(422);
            self.message = self.$t('pages.ChangePassword.messages.validation');
            break;
          default:
            console.log('default');
            self.message = self.$t('pages.ChangePassword.messages.default');
        }
        self.canSubmit = true;
        console.log('Message', self.message);
      }

      self.message = null;
      self.variant = null;
      UserService.changePassword({
        request: this.request
      }).then(success, error);
    }
  }
}
</script>
